/**
 * 전역 토스트 — 주로 "전제조건" 에러(action 버튼을 가진 ApiError)를 화면 우하단에
 * 노출하기 위한 스토어. http 인터셉터가 action 있는 에러를 여기로 push 하면,
 * App.vue 에 한 번 마운트된 GlobalToasts 가 메시지 + 조치 버튼을 렌더한다.
 * 이로써 474곳 개별 에러 표시를 고치지 않고도 백엔드의 action 이 앱 전역에서 보인다.
 */
import { defineStore } from 'pinia';

export interface ToastAction {
  label: string;
  href: string;
}

export interface ToastItem {
  id: number;
  message: string;
  action?: ToastAction;
}

let seq = 0;

export const useToastStore = defineStore('toast', {
  state: () => ({
    items: [] as ToastItem[],
  }),
  actions: {
    push(message: string, action?: ToastAction): number {
      const id = ++seq;
      this.items.push({ id, message, ...(action ? { action } : {}) });
      // 조치 버튼이 있으면 사용자가 클릭할 시간을 더 준다.
      const ttl = action ? 12000 : 6000;
      window.setTimeout(() => this.dismiss(id), ttl);
      return id;
    },
    dismiss(id: number): void {
      this.items = this.items.filter((i) => i.id !== id);
    },
  },
});
